import { render, staticRenderFns } from "./plus-template-edit.vue?vue&type=template&id=52109b61&scoped=true"
import script from "./plus-template-edit.vue?vue&type=script&lang=ts"
export * from "./plus-template-edit.vue?vue&type=script&lang=ts"
import style0 from "./plus-template-edit.vue?vue&type=style&index=0&id=52109b61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52109b61",
  null
  
)

export default component.exports